export default {
  inbound: 'inbound',
  outbound: 'outbound',
}
